import React, { useState,useEffect } from "react";
import { Route, Routes,useLocation, Outlet} from "react-router-dom";
import Home from "./Home";
import Footer from "../../Components/Footer";
import Navbar from "../../Components/NavHeader";
import RoomDetail from "./RoomDetails";
import AvailableRooms from "./AvailableRooms";
import Profile from "./Profile";
import PastBoookings from "./PastBoookings";
import Success from "./Success";

const HomeLayout = (props) => {
const location = useLocation()
  const [, setCurrentPath] = useState(
    location?.pathname
  );

  useEffect(() => {
    setCurrentPath(location?.pathname);
  }, [location]);


  return (

<>

      <Navbar />
 
            <Routes>

              <Route index  element={<Home/>}
              />

             <Route
                path={`available-rooms`}
                 element={<AvailableRooms/>}
              /> 

              <Route
                path={`rooms/:code`}
                element={<RoomDetail/>}
              />

              <Route
                path={`profile`}
                element={<Profile/>}
              />

              
               <Route
                path={`past-bookings`}
                element={<PastBoookings/>}
              />
           
              <Route  path={`success/:token`} element={<Success/>} />
          
            </Routes>
    
      <Footer />

      <Outlet />
   </>
  
  );
};

export default HomeLayout;
